import { render, staticRenderFns } from "./PlanNewForm.vue?vue&type=template&id=7225d29d&scoped=true&"
import script from "./PlanNewForm.vue?vue&type=script&lang=js&"
export * from "./PlanNewForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanNewForm.vue?vue&type=style&index=0&id=7225d29d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225d29d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VTextField})
